import {validateFeedbackAttachment,FEEDBACK_ATTACHMENT_MAX_BYTES} from './model.js';

const EXTENSIONS=Object.freeze({
  'image/jpeg':'jpg',
  'image/png':'png',
  'image/webp':'webp'
});

function required(value,label,max=128){
  const text=String(value??'').trim();
  if(!text)throw new TypeError(label+' is required');
  if(text.length>max)throw new TypeError(label+' is too long');
  return text;
}

function safeId(value){
  const text=String(value??'').replace(/[^A-Za-z0-9_.:-]/g,'').slice(0,64);
  return text||String(Date.now());
}

export function createFeedbackAttachmentProvider({
  storage,
  createId=()=>globalThis.crypto?.randomUUID?.()||String(Date.now())
}={}){
  if(typeof storage?.upload!=='function'||typeof storage?.remove!=='function'){
    throw new TypeError('feedback attachment storage upload/remove is required');
  }

  async function upload({userId,requestId,file}={}){
    const owner=required(userId,'userId');
    const request=required(requestId,'requestId',80);
    const mimeType=String(file?.type||'').trim().toLowerCase();
    const extension=EXTENSIONS[mimeType];
    if(!extension)throw new TypeError('Unsupported feedback attachment type');
    const sizeBytes=Number(file?.size);
    if(!Number.isInteger(sizeBytes)||sizeBytes<1||sizeBytes>FEEDBACK_ATTACHMENT_MAX_BYTES){
      throw new TypeError('Feedback attachment size is outside the supported range');
    }
    const path=`${owner}/feedback/${request}/attachment_${safeId(createId())}.${extension}`;
    const descriptor=validateFeedbackAttachment({path,mimeType,sizeBytes});
    await storage.upload({
      userId:owner,
      path:descriptor.path,
      file,
      mimeType:descriptor.mimeType,
      sizeBytes:descriptor.sizeBytes,
      upsert:false
    });
    return descriptor;
  }

  async function remove({userId,attachment}={}){
    const descriptor=validateFeedbackAttachment(attachment);
    if(!descriptor)return Object.freeze({ok:true,status:'nothing_to_remove'});
    return storage.remove({userId:required(userId,'userId'),paths:[descriptor.path]});
  }

  return Object.freeze({upload,remove});
}
